module.exports = __webpack_public_path__ + "images/Pe-icon-7-stroke.svg";